import { __exports as r } from "./index114.js";
import { __require as s } from "./index115.js";
import { __require as n } from "./index88.js";
var o;
function d() {
  if (o) return r;
  o = 1;
  var a = r && r.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.Alias = void 0;
  var u = a(s()), i = n();
  function e(t, p) {
    i.Facade.call(this, t, p);
  }
  return r.Alias = e, u.default(e, i.Facade), e.prototype.action = function() {
    return "alias";
  }, e.prototype.type = e.prototype.action, e.prototype.previousId = function() {
    return this.field("previousId") || this.field("from");
  }, e.prototype.from = e.prototype.previousId, e.prototype.userId = function() {
    return this.field("userId") || this.field("to");
  }, e.prototype.to = e.prototype.userId, r;
}
export {
  d as __require
};
//# sourceMappingURL=index89.js.map
